import {
    GETUSERSMEMBERS_SUCCESS,
    GETUSERSMEMBERS_FAIL,

    
} from "../actions/types";

const initialState = [];

export default function fcUserReducer(FClist = initialState,action){
    const {list,type} = action;

    switch(type) {
        case GETUSERSMEMBERS_SUCCESS:
            return {...list};
        case GETUSERSMEMBERS_FAIL:
            return FClist;
        default:
            return FClist;
    }

}